import { FuseAnimate } from '@fuse';
import { Card, Icon, Typography } from '@material-ui/core';
import clsx from 'clsx';
import moment from 'moment';
import React from 'react';
import setDescriptionStyle from './setDescriptionStyle';

function AnotacaoListItem(props) {
    return (
        <FuseAnimate animation="transition.fadeIn" duration={400} delay={100}>
            <Card
                className={clsx("cursor-pointer", props.className)}
                onClick={() => props.openDialog(props.anotacao)}
            >
                

                {props.anotacao.titulo && props.anotacao.titulo !== ""  (
                    <Typography className="p-16 pb-8 text-14 font-bold">
                        {props.anotacao.titulo}
                    </Typography>
                )}
                {props.anotacao.descricao && props.anotacao.descricao !== "" && props.anotacao.arquivado === false && (
                    <Typography
                        className="py-8 px-16"
                        component="div"
                    >
                        <div
                            className={clsx("w-full break-words", props.variateDescSize ? "font-200" : "text-14")}
                            ref={el => {
                                setTimeout(() => setDescriptionStyle(props.anotacao.descricao, el, props.variateDescSize));
                            }}>
                            {props.anotacao.descricao}
                        </div>
                    </Typography>
                )}

                {props.anotacao.descricao && props.anotacao.descricao !== "" && props.anotacao.arquivado === true && (
                    <Typography
                        className="py-8 px-16"
                        component="div"
                    >
                        <div
                            className={clsx("w-full break-words line-through", props.variateDescSize ? "font-200" : "text-14")}
                            ref={el => {
                                setTimeout(() => setDescriptionStyle(props.anotacao.descricao, el, props.variateDescSize));
                            }}>
                            {props.anotacao.descricao}
                        </div>
                    </Typography>
                )}

                {props.anotacao.checklist && props.anotacao.checklist.length > 0 && (
                    <ul className="py-8 px-16 flex flex-wrap list-reset">
                        {props.anotacao.checklist.map(item => (
                            <li key={item.id} className="flex items-center w-full">
                                <Icon color="action" className="mr-8 text-16">{item.checked ? "check_box_outline" : "check_box_outline_blank"}</Icon>
                                <Typography
                                    className={clsx("truncate", item.checked && "line-through")}
                                    color={item.checked ? "textSecondary" : "inherit"}
                                >
                                    {item.text}
                                </Typography>
                            </li>
                        ))}
                    </ul>
                )}
                {(props.anotacao.dataupt) && (
                    <div className="flex flex-col w-full px-16 pt-8">
                        <Typography color="textSecondary" className="text-10 text-end whitespace-no-wrap">
                           Atualizado: {moment(props.anotacao.dataupt).format('DD/MM/YYYY HH:MM')}
                        </Typography>
                    </div>
                )}
            </Card>
        </FuseAnimate>
    );
}

export default AnotacaoListItem;
